<template>
	<div style="height: 100vh;background-color: #fff;">
		<div>
			<!-- <a href="../../resources/stop_table/20220607/20220601POSTEB.xlsx"></a> -->
			<el-table :data="tableData" stripe style="width: 100%"
				:default-sort="{prop: 'date', order: 'descending'}">
				<el-table-column prop="date" label="更新日期" align="center" sortable width="180"></el-table-column>
				<el-table-column prop="name" label="名称" align="center" width="180"></el-table-column>
				<el-table-column prop="type" label="文件类型" align="center" width="110"></el-table-column>
				<el-table-column prop="describe" label="描述" align="center" width="220"></el-table-column>

				<el-table-column prop="issued_by" label="发布人员" width="140" align="center"></el-table-column>
				<el-table-column prop="download_link" label="下载地址" align="center">
					<template  #default="scope">
						<a :href="scope.row.download_link" ref="external nofollow" :download="scope.row.name" style="text-decoration:none;color: #01AAED;">点此下载</a>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tableData: [{
						date: '2025-06-11 14:20:00',
						name: '快递公司红章证明-海南蝴蝶台风-文昌-82011',
						type: '图片',
						describe: '',
						issued_by: "",
						download_link: 'http://8.134.179.130:6868/20250612081038.jpg'
					},
					{
						date: '2025-06-11 14:20:00',
						name: '快递公司红章证明-海南蝴蝶台风-华南06-82012',
						type: '图片',
						describe: '',
						issued_by: "",
						download_link: 'http://8.134.179.130:6868/20250612081038.jpg'
					},
					{
						date: '2025-06-11 14:20:00',
						name: '快递公司红章证明-海南蝴蝶台风-华南08-86017',
						type: '图片',
						describe: '',
						issued_by: "",
						download_link: 'http://8.134.179.130:6868/20250612081038.jpg'
					},
					{
						date: '2025-06-11 14:20:00',
						name: '快递公司红章证明-海南蝴蝶台风-海口市场-82014',
						type: '图片',
						describe: '',
						issued_by: "",
						download_link: 'http://8.134.179.130:6868/20250612081038.jpg'
					}, {
						date: '2025-06-12 11:22:00',
						name: '全网时效报表20250612',
						type: '表格',
						describe: '',
						issued_by: "",
						download_link: 'http://8.134.179.130:6868/20250612081038.jpg'
					}, {
						date: '2025-06-12 11:23:50',
						name: '海南路由分析2025061201',
						type: '表格',
						describe: '',
						issued_by: "",
						download_link: 'http://8.134.179.130:6868/20250612081038.jpg'
					}, {
						date: '2025-06-12 15:22:00',
						name: '快件操作指引补充-20250601',
						type: '文档',
						describe: '',
						issued_by: "",
						download_link: 'http://8.134.179.130:6868/20250612081038.jpg'
					}, {
						date: '2025-06-12 13:13:02',
						name: '202506航空件准时率',
						type: '表格',
						describe: '',
						issued_by: "",
						download_link: 'http://8.134.179.130:6868/20250612081038.jpg'
					}, {
						date: '2025-06-12 09:18:08',
						name: '常用账号密码',
						type: '表格',
						describe: '',
						issued_by: "",
						download_link: 'http://8.134.179.130:6868/20250612081038.jpg'
					}, {
						date: '2025-06-13 09:33:12',
						name: '海南台风中转停滞未发出11-12',
						type: '表格',
						describe: '',
						issued_by: "",
						download_link: 'http://8.134.179.130:6868/20250612081038.jpg'
					}, {
						date: '2025-06-13 09:33:38',
						name: '台风预报-20250613085011',
						type: '图片',
						describe: '',
						issued_by: "",
						download_link: 'http://8.134.179.130:6868/20250612081038.jpg'
					},
					{
						date: '2023-03-08',
						name: '菜鸟打印组件',
						type: '应用程序',
						describe: '菜鸟打印组件',
						issued_by: "林桦",
						download_link: 'http://cloudprint.cainiao.com/cloudprint/client/CNPrintSetup.exe'
					},
					{
						date: '2023-03-20',
						name: '快宝云打印代理',
						type: '应用程序',
						describe: '快宝云打印代理',
						issued_by: "hello",
						download_link: 'https://ckd.so/ydy'
					},
					{
						date: '2023-03-26',
						name: '妈妈驿站PC客户端',
						type: '应用程序',
						describe: '驿站pc终端',
						issued_by: "圆通下载中心",
						download_link: 'http://ewei-web-saas.ewei.com/f4111f20ae3311ebadb38ddebd715474?attname=%E5%A6%88%E5%A6%88%E9%A9%BF%E7%AB%99PC%E7%89%88%E5%AE%A2%E6%88%B7%E7%AB%AF.exe&sign=863390aae3b39e30593c19359f9eafd9&t=6417f09a'
					}
				]
			}
		},
		methods: {

		}
	}
</script>

<style scoped>
</style>